import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMeshOrganicBoundary = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.65,
		children: [/* @__PURE__ */ _jsx("path", { d: "m3 7 9-5 5 4 1 5 4 5-4 6-9-1-7-6Z" }), /* @__PURE__ */ _jsx("path", { d: "M17 6 3 7l15 4-16 4m16-4L9 21l13-5" })]
	})
});
export default SvgIconMeshOrganicBoundary;
